<template>
  <b-form-group :id="id">
    <b-form-checkbox-group
      buttons
      stacked
      button-variant="outline-primary rounded d-flex align-items-center"
      v-model="selected"
      @change="optionSelected"
      class="w-100"
      :aria-label="question"
      tabindex="-1"
    >
      <b-form-checkbox
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        role="checkbox"
        class="mb-2"
      >
        {{ option.text }}
      </b-form-checkbox>
    </b-form-checkbox-group>
  </b-form-group>
</template>

<script>
export default {
  name: "CheckboxPrompt",
  props: {
    id: String,
    question: String,
    answers: Array,
    userAnswers: Array,
  },
  data() {
    return {
      selected: this.userAnswers.map((a) => a.value),
    };
  },
  methods: {
    optionSelected() {
      setTimeout(() => {
        this.$emit("optionSelected", { answers: this.selected });
      }, 100);
    },
  },
  computed: {
    options() {
      return this.answers.map((answer) => {
        return { text: answer.value, value: answer.id };
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .btn-group-vertical {
  .btn-outline-primary {
    color: $color-dark;
    border-color: $color-dark;
    input {
      position: static;
      margin-right: 8px;
      width: 24px;
      height: 24px;
      -moz-appearance: initial; // Hack for Firefox Browsers
      outline: none;
      &:after {
        width: 26px;
        height: 26px;
        border-radius: 4px;
        top: -1px;
        left: -1px;
        position: relative;
        content: "";
        display: inline-block;
        visibility: visible;
        border: 1px solid $color-dark;
        background: white;
      }
    }
    &.active,
    &.active.focus {
      background: $color-blue-light;
      color: $color-dark;
      border: 2px solid $color-blue;
      input {
        &:after {
          background: $color-blue !important;
          border: 1px solid $color-blue;
          content: url("/images/checked.svg");
          text-align: center;
          line-height: 26px;
        }
      }
    }
    &:not(.active) {
      padding: calc(1rem + 1px) calc(0.75rem + 1px);
      &:hover {
        padding: 1rem 0.75rem;
        background: transparent;
        border: 2px solid $color-blue;
      }
    }
  }
}
</style>
